var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "start"
  }, [_vm.sample ? _c('send-sample-dialog', {
    attrs: {
      "sample": _vm.sample,
      "hash": _vm.$route.hash
    }
  }) : _vm._e(), _c('start-header', {
    attrs: {
      "bg": _vm.backgrounds[_vm.backgroundI].bg
    },
    on: {
      "loaded-bg": _vm.enqueueNextBackground
    },
    scopedSlots: _vm._u([{
      key: "h1",
      fn: function () {
        return [_c('div', {
          staticClass: "text-center",
          style: {
            color: _vm.backgrounds[_vm.backgroundI].color
          }
        }, [_vm._v(" Greeting cards and invitations for any occasion ")])];
      },
      proxy: true
    }, {
      key: "append-inner",
      fn: function () {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('v-btn', {
          staticClass: "btn-pop",
          attrs: {
            "large": "",
            "rounded": "",
            "dark": "",
            "color": "ec-blue",
            "title": _vm.backgrounds[_vm.backgroundI].title + ' demo',
            "to": {
              hash: '#demo-' + _vm.backgrounds[_vm.backgroundI].name
            }
          }
        }, [_vm._v(" Try demo… ")])], 1)];
      },
      proxy: true
    }])
  }), _c('div', {
    staticClass: "mt-n16 pt-6 overflow-clip"
  }, [_c('div', {
    staticClass: "white pt-6 mx-n16 px-16",
    staticStyle: {
      "border-radius": "50% / 32px",
      "border-bottom-left-radius": "0",
      "border-bottom-right-radius": "0",
      "box-shadow": "0 0 24px #0008"
    }
  }, [_c('sticky-scroll', {
    staticClass: "mt-12 mb-0 overflow-visible relative",
    staticStyle: {
      "z-index": "4"
    }
  }, [_c('v-container', {
    staticClass: "d-flex pr-md-25pct",
    attrs: {
      "id": "search",
      "fluid": ""
    }
  }, [_c('div', {
    staticClass: "flex-grow-1 relative",
    attrs: {
      "id": "search-field"
    }
  }, [_c('v-autocomplete', {
    ref: "search",
    staticClass: "white",
    class: {
      'elevation-20': _vm.$vuetify.breakpoint.mdAndUp
    },
    staticStyle: {
      "pointer-events": "auto"
    },
    attrs: {
      "outlined": "",
      "dense": "",
      "rounded": "",
      "hide-details": "",
      "clearable": "",
      "single-line": "",
      "label": "Search all categories",
      "item-text": "title",
      "attach": "#search-field",
      "items": _vm.categoriesFilter,
      "search-input": _vm.searchInput
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.searchInput = $event;
      },
      "update:search-input": function ($event) {
        _vm.searchInput = $event;
      },
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return function () {
          return _vm.searchInput && _vm.$router.push({
            name: 'catalog-category',
            params: {
              category: 'all'
            },
            query: {
              q: _vm.searchInput
            }
          });
        }.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (_ref) {
        var item = _ref.item;
        return [_c('v-list-item', {
          attrs: {
            "to": {
              name: 'catalog-category',
              params: {
                category: item.name
              }
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-2",
          class: {
            'icon-animated': item.title == 'Animated'
          },
          domProps: {
            "innerHTML": _vm._s(item.icon)
          }
        }), _c('v-list-item-title', {
          domProps: {
            "textContent": _vm._s(item.title)
          }
        })], 1)];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c('div', [_vm.loadStatus.pending ? _c('v-subheader', {
          staticClass: "grey--text font-italic"
        }, [_vm._v("Loading categories…")]) : _vm._e()], 1)];
      },
      proxy: true
    }, {
      key: "prepend-item",
      fn: function () {
        return [_vm.searchInput ? _c('v-list-item', {
          attrs: {
            "to": {
              name: 'catalog-category',
              params: {
                category: 'all'
              },
              query: {
                q: _vm.searchInput
              }
            }
          }
        }, [_c('v-icon', {
          staticClass: "mr-2",
          domProps: {
            "innerHTML": _vm._s(_vm.mdiMagnify)
          }
        }), _c('v-list-item-title', [_vm._v(" Search all cards / invitations for "), _c('span', {
          staticClass: "font-italic"
        }, [_vm._v(_vm._s(_vm.searchInput))])])], 1) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.search,
      callback: function ($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  })], 1), _c('v-btn', {
    directives: [{
      name: "blur",
      rawName: "v-blur"
    }],
    staticClass: "ml-3",
    class: {
      'elevation-20': _vm.$vuetify.breakpoint.mdAndUp
    },
    attrs: {
      "fab": "",
      "small": "",
      "color": "primary",
      "aria-label": "Search",
      "loading": _vm.loadStatus.pending
    },
    on: {
      "click": function () {
        if (_vm.searchInput) {
          _vm.$router.push({
            name: 'catalog-category',
            params: {
              category: 'all'
            },
            query: {
              q: _vm.searchInput
            }
          });
        } else {
          _vm.$refs.search.focus();
          _vm.$refs.search.isMenuActive = true;
        }
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiMagnify)
    }
  })], 1)], 1), _vm.$vuetify.breakpoint.smAndDown ? [_c('div', {
    ref: "xs-preview-bg",
    staticClass: "absolute-fill mt-n9",
    staticStyle: {
      "z-index": "-1",
      "background": "linear-gradient(#FFF 10%, #FAFAFA 90%, #FAFAFA00)"
    }
  }), _vm.focused ? _c('router-link', {
    staticClass: "mt-3 d-block mx-auto relative",
    staticStyle: {
      "max-width": "min(60%, 400px)",
      "aspect-ratio": "16 / 10"
    },
    attrs: {
      "to": {
        name: 'catalog-category',
        params: {
          category: _vm.focused.name
        }
      }
    }
  }, [_c('outline-laptop', {
    staticStyle: {
      "z-index": "0"
    }
  }, [_c('skin-preview', {
    staticClass: "absolute-fill",
    attrs: {
      "from": "Example sender",
      "to": "Example recipient",
      "mode": "preview",
      "skin": _vm.focused.skin,
      "bg-scale": _vm.$vuetify.breakpoint.xsOnly ? [160, 90] : [320, 180]
    }
  })], 1), _c('outline-phone', {
    staticClass: "absolute",
    staticStyle: {
      "z-index": "1",
      "bottom": "5%",
      "right": "0",
      "width": "22%"
    },
    attrs: {
      "vertical": ""
    }
  }, [_c('skin-preview', {
    staticClass: "absolute-fill",
    attrs: {
      "from": "Example sender",
      "to": "Example recipient",
      "mode": "preview",
      "skin": _vm.focused.skin,
      "bg-scale": _vm.$vuetify.breakpoint.xsOnly ? [160, 90] : [320, 180]
    }
  })], 1), _vm._l(_vm.focused.preview, function (preview, i) {
    return _c('picture', {
      key: _vm.focused.title + i,
      staticClass: "preview-card"
    }, [preview.mp4 ? _c('source', {
      attrs: {
        "type": "video/mp4",
        "srcset": preview.mp4
      }
    }) : _vm._e(), _c('img', {
      staticClass: "d-block absolute elevation-20",
      attrs: {
        "loading": "lazy",
        "type": 'image/' + (preview.webp ? 'webp' : 'jpeg'),
        "src": preview.webp ? preview.webp : preview.jpg,
        "alt": `${_vm.focused.title} sample card page ${i + 1}`
      }
    })]);
  })], 2) : _vm._e()] : _vm._e()], 2), _c('div', {
    staticClass: "my-0 px-0"
  }, [_c('div', {
    staticClass: "py-6"
  }), _vm._l(_vm.categories, function (c, j) {
    return [j && c.seasonality && c.seasonality != _vm.categories[j - 1].seasonality ? _c('v-container', {
      staticClass: "pt-6 pb-0 text--label-active",
      attrs: {
        "fluid": ""
      }
    }, [c.seasonality == 1 ? [_vm._v("Featured seasonal occasions")] : c.seasonality == 3 ? [_vm._v("Other occasions")] : [_vm._v(" ")]], 2) : _vm._e(), !_vm.spotlight || !c.type || _vm.spotlight == c.type ? _c('v-list-item', {
      ref: "category",
      refInFor: true,
      staticClass: "pa-0 item",
      class: {
        active: _vm.focused === c
      },
      attrs: {
        "to": {
          name: 'catalog-category',
          params: {
            category: c.name
          }
        }
      },
      nativeOn: {
        "mouseover": function ($event) {
          return _vm.onMouseover(c);
        },
        "touchstart": function ($event) {
          _vm.focused = c;
        }
      }
    }, [_c('v-container', {
      staticClass: "d-flex align-center overflow-visible relative pa-6 pl-md-3 pr-md-25pct",
      attrs: {
        "fluid": ""
      }
    }, [_c('div', {
      staticClass: "mr-6 flex-grow-1"
    }, [_c('div', {
      staticClass: "d-flex align-center"
    }, [_c('v-icon', {
      staticClass: "c-icon",
      style: {
        color: c.icon_color || '#28547e'
      },
      domProps: {
        "innerHTML": _vm._s(c.icon)
      }
    }), _c('h3', {
      staticClass: "c-title title header-font ml-2",
      style: {
        color: c.title_color || '#28547e'
      },
      domProps: {
        "innerHTML": _vm._s(c.title)
      }
    })], 1), c.description ? _c('div', {
      staticClass: "c-desc mt-2 ml-8 text-body-2 description",
      style: {
        color: c.title_color || '#28547e'
      },
      domProps: {
        "innerHTML": _vm._s(c.description)
      }
    }) : _vm._e()]), _c('v-icon', {
      staticClass: "right",
      domProps: {
        "innerHTML": _vm._s(_vm.mdiChevronRight)
      }
    }), _vm.$vuetify.breakpoint.mdAndUp ? _c('v-lazy', {
      staticClass: "flex-grow-0 absolute overflow-visible item-preview"
    }, [_c('div', [_c('outline-laptop', {
      staticStyle: {
        "z-index": "0"
      }
    }, [_c('skin-preview', {
      staticClass: "absolute-fill",
      attrs: {
        "from": "Example sender",
        "to": "Example recipient",
        "mode": "preview",
        "skin": c.skin
      }
    })], 1), _c('outline-phone', {
      staticClass: "absolute",
      staticStyle: {
        "z-index": "1",
        "bottom": "5%",
        "right": "0",
        "width": "22%"
      },
      attrs: {
        "vertical": ""
      }
    }, [_c('skin-preview', {
      staticClass: "absolute-fill",
      attrs: {
        "from": "Example sender",
        "to": "Example recipient",
        "mode": "preview",
        "skin": c.skin
      }
    })], 1), _vm._l(c.preview, function (preview, i) {
      return _c('picture', {
        key: c.title + i,
        staticClass: "preview-card"
      }, [preview.mp4 ? _c('source', {
        attrs: {
          "type": "video/mp4",
          "srcset": preview.mp4
        }
      }) : _vm._e(), _c('img', {
        staticClass: "d-block absolute elevation-20",
        attrs: {
          "loading": "lazy",
          "type": 'image/' + (preview.webp ? 'webp' : 'jpeg'),
          "src": preview.webp ? preview.webp : preview.jpg,
          "alt": `${c.title} sample card page ${i + 1}`
        }
      })]);
    })], 2)]) : _vm._e()], 1)], 1) : _vm._e()];
  }), _c('div', {
    staticClass: "bottom-spacer"
  })], 2)], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }